/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-19",
    versionChannel: "nightly",
    buildDate: "2023-12-19T00:15:23.146Z",
    commitHash: "ba6ba842d7f539b82087b3227999c3c35f7c0e68",
};
